import { useEffect, useMemo, useRef, useState } from "react";
import "./IntroBanneSlide.css";
import { verificaAdmin } from "../../../../components/utils/verificaAdmin";
import AdminBanner from "./AdminBanner/AdminBanner";

function IntroBanneSlide({ banners, loading }) {
  const [indexAtual, setIndexAtual] = useState(0);
  const timeoutRef = useRef(null);

  const [bannersLocais, setBannersLocais] = useState([]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setBannersLocais(banners);
  }, [banners]);

  const [abrirAdminBanner, setAbrirAdminBanner] = useState(false);

  const isAdmin = verificaAdmin();

  //console.log(isAdmin);

  const bannersIntro = useMemo(() => {
    if (!Array.isArray(bannersLocais)) return [];

    const localizacao = isMobile
      ? "introbannerslidemobile"
      : "introbannerslide";

    return bannersLocais
      .filter((b) => b.localizacao === localizacao)
      .sort((a, b) => a.ordem - b.ordem);
  }, [bannersLocais, isMobile]);

  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const startTimer = () => {
    if (bannersIntro.length <= 1) return;

    clearTimer();
    timeoutRef.current = setTimeout(() => {
      setIndexAtual(prev =>
        (prev + 1) % bannersIntro.length
      );
    }, 5000);
  };

  // Auto slide
  useEffect(() => {
    if (bannersIntro.length === 0) return;

    startTimer();
    return clearTimer;
  }, [indexAtual, bannersIntro]);

  // 🚫 Se não tiver banner, NÃO renderiza nada
  if (loading || bannersIntro.length === 0) return null;

  const handlePrev = () => {
    if (bannersIntro.length <= 1) return;

    setIndexAtual(prev =>
      (prev - 1 + bannersIntro.length) % bannersIntro.length
    );
    startTimer();
  };

  const handleNext = () => {
    if (bannersIntro.length <= 1) return;

    setIndexAtual(prev =>
      (prev + 1) % bannersIntro.length
    );
    startTimer();
  };

  return (
    <section className="intro-part1-banner">

      {isAdmin && (
        <button
          className="btn-editar-banner"
          onClick={() => setAbrirAdminBanner(true)}
        >
          Editar
        </button>
      )}

      <div
        className="intro-part1-carousel"
        style={{
          transform: `translateX(-${indexAtual * 100}%)`,
          transition: "transform 0.5s ease-in-out",
        }}
      >
        {bannersIntro.map(banner => (
          <div className="intro-part1-slide" key={banner.id}>
            <img
              src={
                banner.imagem.startsWith("http")
                  ? banner.imagem
                  : process.env.PUBLIC_URL + banner.imagem
              }
              alt={`Banner ${banner.ordem}`}
            />
          </div>
        ))}
      </div>

      {/* Setas só fazem sentido se tiver mais de 1 */}
      {bannersIntro.length > 1 && (
        <>
          <button className="arrow prev" onClick={handlePrev}>‹</button>
          <button className="arrow next" onClick={handleNext}>›</button>
        </>
      )}

      {abrirAdminBanner && (
        <div
          className="admin-modal-overlay"
          onClick={() => setAbrirAdminBanner(false)}
        >
          <div
            className="adminbanner-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <AdminBanner
              localizacao="introbannerslide"
              onClose={() => setAbrirAdminBanner(false)}
              onBannerAtualizado={(bannerAtualizado) => {
                setBannersLocais((prev) =>
                  prev.map((b) =>
                    b.id === bannerAtualizado.id
                      ? bannerAtualizado
                      : b
                  )
                );
              }}
            />
          </div>
        </div>
      )}
    </section>
  );
}

export default IntroBanneSlide;
